import { useContext, useEffect, useState } from "react";
import BasketItemDetails from "./BasketItemDetails";
import "../styles/basket.css";
import appConst from "../Utilities/appConst.json";
import { colorMap, materialMap, sizeMap } from "../Utilities/mapUtil";
import { LanguageContext } from "../context/language/LanguageContext";
import { useDispatch, useSelector } from "react-redux";
import BasketItemCard from "./BasketItemCard";
import CbImg from "./CbImg";
import {
  updateBasketItemColor,
  updateBasketItemSize,
} from "../store/basket";
import useBasketItemHelpers from "../hooks/useBasketItemHelpers";

const BasketItemTile = (props) => {
  const dispatch = useDispatch();
  const languageContext = useContext(LanguageContext);
  const frames = useSelector((state) => state.basket.frames);
  const stocks = useSelector((state) => state.user.stocks);

  const [colorsArray, setColorsArray] = useState([]);
  const [sizesArray, setSizeArray] = useState([]);
  const [dropDowns, setDropDowns] = useState([]);
  const [title, setTitle] = useState();

  useEffect(() => {
    const colorsArray = frames
      // Kappa (קאפה) type is not available for purchase yet, so it is hidden
      .filter((frame) => frame.frame_color !== appConst.FRAME_COLOR_KAPPA)
      .map((frame) => {
        return {
          value: frame.frame_color,
          label: languageContext.getTranslation(colorMap.get(frame.frame_color)),
          disabled: isDisbled(frame),
          frameUrl: frame.url,
        };
      });

    const sizesArray = stocks
      .filter((stock) => stock.color_id === props.item.frame_color)
      .map((stock) => {
        return {
          value: stock.format_id,
          label: languageContext.getTranslation(sizeMap.get(stock.format_id)),
          disabled: !stock.is_available,
        };
      });

    setColorsArray(
      colorsArray.sort((a, b) =>
        a.disabled > b.disabled ? 1 : a.disabled < b.disabled ? -1 : 0
      )
    );
    setSizeArray(
      sizesArray.sort((a, b) =>
        a.disabled > b.disabled ? 1 : a.disabled < b.disabled ? -1 : 0
      )
    );
  }, [frames, stocks, props.item.format, props.item.frame_color]);

  useEffect(() => {
    setDropDowns([
      {
        id: "tile-size",
        array: sizesArray,
        title: languageContext.getTranslation(appConst.SIZE),
        value: props.item.format,
        placeholder: sizesArray?.find((e) => e.value == props.item.format)
          ?.label,
        isDisabled: sizesArray.length === 0,
        setValue: setSizeValue,
        variant: "tileSize",
      },
      {
        id: "tile-frame-color",
        array: colorsArray,
        title: languageContext.getTranslation(appConst.TYPE),
        value: props.item.frame_color,
        placeholder: colorsArray?.find((e) => e.value == props.item.frame_color)
          ?.label,
        isDisabled: colorsArray.length === 0,
        setValue: setColorValue,
        variant: "tileType",
      },
    ]);
  }, [colorsArray, sizesArray, languageContext, props.item.frame_color, props.item.format]);

  // title
  useEffect(() => {
    setTitle(
      languageContext.getTranslation(
        appConst.SQUARED_LUPA + "_" + materialMap.get(props.item.material)
      )
    );
  }, [languageContext, props.item.material]);

  const { setCountValue, handleChange, getImageUrl } = useBasketItemHelpers({
    dispatch,
    item: props.item,
    props,
  });

  const isDisbled = (frame) => {
    let isDisbled = true;
    const itemFrame = stocks.filter(
      (stock) =>
        stock.color_id === frame.frame_color &&
        stock.format_id === props.item.format
    );

    if (itemFrame.length > 0) {
      isDisbled = !itemFrame[0].is_available;
    }

    return isDisbled;
  };

  const setSizeValue = (value) => {
    dispatch(updateBasketItemSize(value, props.item));
  };

  const setColorValue = (value) => {
    const frame = frames.find((frame) => frame.frame_color === value);
    const url = frame ? frame.url : "";
    dispatch(updateBasketItemColor(value, url, props.item));
  };

  return (
    <BasketItemCard
      imageUrl={getImageUrl()}
      imageAlt={title}
      showCheckbox={props.isDeletionMode}
      isChecked={props.isChecked}
      onToggle={handleChange}
      quantity={props.item.quantity}
      setCountValue={setCountValue}
      dropDowns={dropDowns}
      item={props.item}
      imageContent={
        <CbImg
          isTile={true}
          isChecked={props.isChecked}
          setSelectedValue={props.setSelectedValue}
          item={props.item}
          frameClasses={"basket_item"}
          showCheckbox={false}
        />
      }
    >
      <BasketItemDetails
        quantity={props.item.quantity}
        item={props.item}
        dropDowns={dropDowns}
        title={title}
        isShow={true}
        setCountValue={setCountValue}
        imageUrl={getImageUrl()}
        tuneSettingsTitle={title}
      />
    </BasketItemCard>
  );
};
export default BasketItemTile;
